module.exports = __webpack_public_path__ + "static/img/renauld.389ac00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/renauld.png
// module id = BJra
// module chunks = 0